
import { Zap, Shield, BarChart, Users } from "lucide-react";
import { useTranslation } from "react-i18next";

const features = [
  {
    icon: Zap,
    translationKey: "rapid"
  },
  {
    icon: Shield,
    translationKey: "security"
  },
  {
    icon: BarChart,
    translationKey: "analytics"
  },
  {
    icon: Users,
    translationKey: "collaboration"
  }
];

export const Features = () => {
  const { t } = useTranslation();

  return (
    <section id="features" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative">
          <div className="text-center mb-16">
            <div 
              className="opacity-0 animate-fade-in" 
              style={{ animationDelay: '0ms', animationFillMode: 'forwards' }}
            >
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                {t('features.title')}
              </h2>
            </div>
            <div 
              className="opacity-0 animate-fade-in" 
              style={{ animationDelay: '150ms', animationFillMode: 'forwards' }}
            >
              <p className="text-xl text-gray-600">
                {t('features.subtitle')}
              </p>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="opacity-0 animate-fade-in bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow"
              style={{ 
                animationDelay: `${(index + 2) * 150}ms`,
                animationFillMode: 'forwards'
              }}
            >
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4">
                <feature.icon className="w-6 h-6 text-primary" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {t(`features.${feature.translationKey}.title`)}
              </h3>
              <p className="text-gray-600">
                {t(`features.${feature.translationKey}.description`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
